import { useEffect, useState } from "react";

function GalleryImage({ item, onOpen }) {
  const [err, setErr] = useState(false);
  const showImg = item.image_url && !err;
  return (
    <div className="gal-item" onClick={onOpen}>
      {showImg ? (
        <img src={item.image_url} alt={item.caption} loading="lazy" onError={() => setErr(true)} />
      ) : (
        <div className="gal-ph" style={{ display: "grid" }}>
          <i className="fa-solid fa-image" />
          <span>{item.caption}</span>
        </div>
      )}
      <div className="gal-zoom">
        <i className="fa-solid fa-expand" />
      </div>
      <div className="gal-overlay-cap">{item.caption}</div>
    </div>
  );
}

function ImageLightbox({ items, index, setIndex, onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") setIndex((i) => (i + 1) % items.length);
      if (e.key === "ArrowLeft") setIndex((i) => (i - 1 + items.length) % items.length);
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [items.length, setIndex, onClose]);

  const item = items[index];
  return (
    <div className="img-overlay open" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="img-counter">
        {index + 1} / {items.length}
      </div>
      <button className="img-close" onClick={onClose}>
        &times;
      </button>
      <button className="img-nav prev" onClick={() => setIndex((i) => (i - 1 + items.length) % items.length)}>
        <i className="fa-solid fa-chevron-left" />
      </button>
      <img src={item.image_url} alt={item.caption} />
      <div className="cap">{item.caption}</div>
      <button className="img-nav next" onClick={() => setIndex((i) => (i + 1) % items.length)}>
        <i className="fa-solid fa-chevron-right" />
      </button>
    </div>
  );
}

export default function Gallery({ items }) {
  const [index, setIndex] = useState(null);

  return (
    <section id="gallery" className="section gallery">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">Inside our shop</span>
          <h2>Gallery</h2>
          <p>A look at our shop, products, team and the clients we serve. Tap any image to view it larger.</p>
        </div>
        <div className="gal-grid">
          {items.map((g, i) => (
            <GalleryImage key={g.id} item={g} onOpen={() => setIndex(i)} />
          ))}
        </div>
      </div>
      {index !== null && (
        <ImageLightbox items={items} index={index} setIndex={setIndex} onClose={() => setIndex(null)} />
      )}
    </section>
  );
}
